import React from "react";
import { toastr } from "react-redux-toastr";
import { Lead } from "../../../../core/api/models";
import { DateFormats, getLeadTitle, useLead } from "../../../../core";
import "react-widgets/dist/css/react-widgets.css";
import api from "../../../../api";
import { Controller, useForm } from "react-hook-form";
import { DropdownList } from "react-widgets";
import ErrorMessage from "../../../../components/text/ErrorMessage";
import moment from "moment";

const ConvertAsEnquiry: React.FunctionComponent<{
  leadId?: string;
  leads?: Lead[];
  onClose?: () => void;
  onSuccess?: () => void;
  actionId: string;
  className?: string;
  isQualityOSL?: boolean;
  quality?: string;
}> = (props) => {
  const { convertAsEnquiry, convertAsVSLEnquiry, updating } = useLead(api.lead);

  const { control, handleSubmit, errors } = useForm<{
    leadId: string;
  }>({
    reValidateMode: "onChange",
    mode: "onSubmit",
  });
  const [isSubmiting, setIsSubmiting] = React.useState<boolean>(false);
  const onSubmit = async (data: { leadId: string }) => {
    setIsSubmiting(true);
    if (!props.isQualityOSL) {
      convertAsEnquiry(
        "deal",
        data.leadId,
        () => {
          setIsSubmiting(false);
          toastr.success("Success", "Converted to an opportunity successfully");
          props.onSuccess?.();
        },
        (error) => {
          setIsSubmiting(false);
          if (error?.response?.data?.data?.message) {
            toastr.error("Error", error?.response?.data?.data?.message);
          }
        }
      );
    } else {
      convertAsVSLEnquiry(
        "deal",
        data.leadId,
        "interested",
        () => {
          setIsSubmiting(false);
          toastr.success("Success", "Converted to an opportunity successfully");
          props.onSuccess?.();
        },
        (error) => {
          setIsSubmiting(false);
          if (error?.response?.data?.data?.message) {
            toastr.error("Error", error?.response?.data?.data?.message);
          }
        }
      );
    }
  };

  if (!props.leadId && !props.leads?.length) {
    return <></>;
  }

  const renderLeadOption = () => {
    if (props.leadId) {
      return (
        <Controller
          control={control}
          rules={{ required: "Lead is Required" }}
          name="leadId"
          defaultValue={props.leadId}
          render={() => <></>}
        />
      );
    }
    return (
      <div className="form-group font-weight-semibold mb-3">
        <Controller
          control={control}
          rules={{ required: "Lead is required" }}
          name="leadId"
          defaultValue={props.leads?.[0]._id}
          render={({ onChange, value, name }) => (
            <DropdownList
              data={props.leads?.map((lead) => ({
                _id: lead._id,
                title: `${getLeadTitle(lead)} - Created on ${moment(
                  lead.createdAt
                ).format(DateFormats.NormalDateTimeFormat)} By ${
                  lead?.createdBy?.name || "City Info website"
                }`,
              }))}
              textField="title"
              value={value}
              defaultValue={value}
              valueField="_id"
              onChange={(val) => {
                onChange(val._id);
              }}
              placeholder="Select Lead"
            ></DropdownList>
          )}
        />
        <div>
          <ErrorMessage>{errors.leadId?.message}</ErrorMessage>
        </div>
      </div>
    );
  };

  return (
    <>
      <div
        className="modal fade show in"
        id="exampleModal"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-confirm modal-dialog-centered">
          <div className="modal-content rounded-0">
            <div className="modal-body text-center">
              <form onSubmit={handleSubmit(onSubmit)}>
                {renderLeadOption()}
                <div className="container">
                  <div className="row">
                    {!props.isQualityOSL ? (
                      <div className="col">
                        <p>
                          Are you sure want to convert this lead as opportunity
                        </p>
                      </div>
                    ) : (
                      <div className="col">
                        <p>
                          Are you sure want to convert this Not Intrested lead
                          as Interested & Opportunity
                        </p>
                      </div>
                    )}
                  </div>
                  <div className="row">
                    <div className="col-auto mr-auto">
                      <button
                        type="button"
                        className="btn btn-outline-dark py-2 font-weight-semibold font-normal px-4 mr-1"
                        onClick={props.onClose}
                      >
                        Cancel
                      </button>
                    </div>
                    <div className="col-auto">
                      <button
                        type="submit"
                        className="btn btn-primary py-2 font-weight-semibold font-normal px-4 "
                        onClick={handleSubmit(onSubmit)}
                        disabled={updating}
                      >
                        Convert
                      </button>
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
      <div className="modal-backdrop fade show"></div>
    </>
  );
};

export default ConvertAsEnquiry;
